export default class PricingCountryRequestItem {
  constructor(serviceId) {
    this.ServiceId = serviceId;
    this.SelectedCountryIds = [];
  }

  ServiceId = '';
  SelectedCountryIds = [];

  setIdList(selectedList) {
    const selectedIds = [];
    selectedList.forEach((emp) => {
      if (emp.SelectedInList) {
        selectedIds.push(emp.CountryId);
      }
    });
    this.SelectedCountryIds = selectedIds;
  }
}
